import _             from 'underscore';
import React, { FC } from 'react';
import { useQuery }  from '@apollo/react-hooks';

import { formatOption }                  from '../../../../util';
import { SystemAccountingQueries }       from '../../../../queries';
import { SelectField, SelectFieldProps } from '../../../components/forms';
import { PreSelectedSelectField }        from '../../../../types';

const Dropdown: FC<PreSelectedSelectField> = ( _props ) => {
	
	const { projectIds = null, organizationId = null, isActive = null, ...props } = _props;
	
	let queryWhere = null;
	
	if( !_.isNull( organizationId ) || !_.isNull( organizationId ) || _.isBoolean( isActive ) ){
		queryWhere = { where: { and: [] } }
	}
	
	if( isActive === true ){
		queryWhere.where.and.push( { isActive: { eq: true } } )
	}
	
	if( isActive === false ){
		queryWhere.where.and.push( { isActive: { eq: false } } )
	}
	
	if( !_.isNull( organizationId ) ){
		queryWhere.where.and.push( { organizationId: { eq: organizationId } } )
	}
	
	if( !_.isNull( projectIds ) && _.isArray( projectIds ) ){
		queryWhere.where.and.push( {
			id: { in: projectIds }
		} )
	}
	
	let { data, loading, error, ...req } = useQuery( SystemAccountingQueries.queries.GET_PROJECTS( `id name organization{ name }` ), {
		fetchPolicy: 'cache-and-network',
		variables:   {
			...queryWhere,
			order: [ { name: "ASC" } ]
		}
	} );
	
	let isLoading = ( props.loading || loading );
	
	let options = ( data )
	              ? _.sortBy( data.projects, 'name' )
	                 .map( ( { id, name, organization: { name: organizationName } } ) => formatOption( id, name, { group: organizationName } ) )
	              : [];
	
	return (
		<SelectField
			{ ...props }
			loading={ isLoading }
			options={ options }>
		</SelectField>
	);
};

Dropdown.defaultProps = {};

export { Dropdown as ProjectsDropdown }
